import { myResourceTypeApi } from 'v5/api/resource-types/resource-types.api.connected';
import { myErrorService } from 'v5/services/front/ErrorService/ErrorService.connected';
import { myMetastructureMappingService } from 'v5/services/internal/MetastructureMappingService/MetastructureMappingService.connected';
import { myResourceTypeBindingsService } from 'v5/services/internal/ResourceTypeBindingsService/ResourceTypeBindingsService.connected';
import { createResourceTypeAdminMutationService } from './ResourceTypeAdminMutationService.impl';

export const myResourceTypeAdminMutationService =
  createResourceTypeAdminMutationService({
    api: myResourceTypeApi,
    resourceTypeBindingsService: myResourceTypeBindingsService,
    services: {
      errorService: myErrorService,
      metastructureMappingService: myMetastructureMappingService
    }
  });
